// src/pages/LoginPage/index.jsx
// 登录
import React, { useState, useEffect, useRef } from "react";
import { Input, Button, Checkbox, message as antdMessage } from "antd";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import axios from "axios";
import { getLegalDoc } from "../../utils/legalDocs";
import "./index.less";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../router/RouterPaths";
import loginTopImg from "../../assets/img/bg_login_top.png";

const LoginPage = ({ userId, onFinish, onVisitor }) => {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  // 是否新用户：null=未知, 1=新用户(展示邀请码), 0=老用户(隐藏邀请码)
  const [isNewUser, setIsNewUser] = useState(null);
  const [countdown, setCountdown] = useState(0); // 倒计时状态
  const [isAgreed, setIsAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inviteErrorVisible, setInviteErrorVisible] = useState(false);
  const [legalType, setLegalType] = useState("");
  const timerRef = useRef(null);
  const navigate = useNavigate();

  // 核心优化：倒计时逻辑
  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else {
      if (timerRef.current) clearTimeout(timerRef.current);
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [countdown]);

  // 根据手机号查询是否为新用户，仅新用户才展示邀请码
  useEffect(() => {
    const isValidPhone = /^1[3-9]\d{9}$/.test(phone);

    // 手机号不合法时视为未知，并清空邀请码
    if (!isValidPhone) {
      setIsNewUser(null);
      setInviteCode("");
      return;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        // TODO: 根据手机号查询是否新用户的接口，后端暂未提供
        const { data } = await axios.post(
          `${window.PUBLIC_URL}/medagent/invite/checkNewUser`,
          { phone },
        );

        // 请求期间手机号已变更，丢弃过期结果
        if (cancelled) return;

        if (data.code == 200 || data.code === "200") {
          const newUser = data.data?.newUser;
          setIsNewUser(newUser);
          // 老用户：隐藏并清空邀请码
          if (newUser !== 1) {
            setInviteCode("");
          }
        } else {
          setIsNewUser(null);
        }
      } catch (err) {
        if (cancelled) return;
        console.error("查询是否为新用户失败:", err);
        setIsNewUser(null);
      }
    }, 300);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [phone]);

  const handleGoAgreement = (type, event) => {
    navigate(
      type === "user" ? ROUTE_PATHS.UserAgreement : ROUTE_PATHS.PrivacyPolicy,
    );
    // event?.preventDefault();
    // event?.stopPropagation();
    // // 根据业务需求跳转 URL 或弹出 Modal
    // console.log(`>>> 跳转至: ${type === 'user' ? '用户协议' : '隐私政策'}`);
    // setLegalType(type);
  };

  const getParagraphClassName = (text, index) => {
    if (index === 0 || /^第[一二三四五六七八九十]+条/.test(text))
      return "legal-paragraph heading";
    if (/^\d+\.\d+/.test(text) || /^（\d+）/.test(text))
      return "legal-paragraph item";
    return "legal-paragraph";
  };

  // 发送短信逻辑
  const handleSendSms = async () => {
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      return antdMessage.warning("请输入正确的手机号");
    }

    const apiUrl = `${window.PUBLIC_URL}/medagent/robot/sendSms`;
    const payload = { userId, phone };

    // --- 【日志打印】请求发起前 ---
    console.group(">>> [发送验证码请求]");
    console.log("接口地址:", apiUrl);
    console.log("请求参数 (Payload):", payload);
    console.groupEnd();

    try {
      const { data } = await axios.post(apiUrl, payload);

      // --- 【日志打印】请求成功返回 ---
      console.group("<<< [发送验证码返回]");
      console.log("返回数据内容 (Data):", data);
      console.groupEnd();

      // 需求：通过 60 秒倒计时来反馈发送成功
      if (data.code == 200 || data.code === "200") {
        setCountdown(60); // 开始倒计时
        // 不再弹出成功提示，降低干扰
      } else {
        // 业务逻辑层面的报错（如：发送频率过快等）
        console.warn("<<< [发送验证码业务错误]:", data.data);
        antdMessage.error(data.data || data.msg || "获取验证码失败");
      }
    } catch (err) {
      // --- 【日志打印】接口异常 (网络、404、500 等) ---
      console.group("!!! [发送验证码网络/系统异常]");
      console.error("错误对象详情 (Error Obj):", err);

      if (err.response) {
        // 请求已发出，服务器响应了状态码（4xx, 5xx）
        console.error("HTTP 响应状态码 (Status):", err.response.status);
        console.error(
          "后端返回的原始错误信息 (Response Data):",
          err.response.data,
        );
      } else if (err.request) {
        // 请求已发出，但没收到响应（跨域或断网）
        console.error("请求已发起但未收到响应 (Request):", err.request);
      } else {
        // 设置请求时触发了错误
        console.error("请求设置异常:", err.message);
      }
      console.groupEnd();

      const errorData = err.response?.data;
      const errorMsg =
        (typeof errorData === "string"
          ? errorData
          : errorData?.msg || errorData?.error) || "服务异常";
      antdMessage.error(errorMsg);
    }
  };
  // 登录逻辑优化
  // @param {object} options
  // @param {boolean} options.skipInvite true 时不携带邀请码（跳过邀请码重新登录）
  const doLogin = async ({ skipInvite = false } = {}) => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${window.PUBLIC_URL}/medagent/robot/login`,
        {
          userId,
          phone,
          code,
          inviteCode: skipInvite ? undefined : inviteCode || undefined,
          from: "wt",
        },
      );

      // 接口返回 code: 200 代表成功
      if (data.code == 200 || data.code === "200") {
        antdMessage.success("登录成功");
        // 调用 App.js 传下来的完成回调，更新全局 userId 并解锁游客限制
        // data.data 为接口返回的 userId
        onFinish(
          data.data.userId,
          data.data.newUserFreeTrial,
          data.data.freeTrialDays,
          phone,
          data.data.hasInvite,
        );
      } else if (data.code == 5003 || data.code === "5003") {
        // 邀请码不正确或已失效，弹出邀请码错误弹窗
        setInviteErrorVisible(true);
      } else {
        antdMessage.error(data.data || data.msg || "登录失败");
      }
    } catch (err) {
      antdMessage.error("系统登录异常");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    if (!isAgreed) return antdMessage.warning("请先勾选并同意用户协议");
    if (!phone || !code) return antdMessage.warning("请填写手机号和验证码");
    // 校验 userId 是否为空
    if (!userId) {
      console.error("登录失败：当前 session 的 userId 为空");
      return antdMessage.error("系统初始化异常，请刷新页面重试");
    }

    doLogin();
  };

  // 邀请码弹窗：点击「跳过」，清空邀请码并重新调登录接口（不携带 inviteCode）
  const handleSkipInvite = () => {
    setInviteErrorVisible(false);
    setInviteCode("");
    doLogin({ skipInvite: true });
  };

  // 邀请码弹窗：点击「重输邀请码」，清空邀请码并关闭弹窗
  const handleReenterInvite = () => {
    setInviteErrorVisible(false);
    setInviteCode("");
  };

  const legalDoc = legalType ? getLegalDoc(legalType) : null;

  if (legalDoc) {
    return (
      <div className="login-page-wrapper legal-mode">
        <div className="legal-card">
          <div className="legal-header">
            <button
              className="legal-back-btn"
              type="button"
              onClick={() => setLegalType("")}
            >
              <LeftOutlined />
              <span>返回登录</span>
            </button>
            <h1>{legalDoc.title}</h1>
          </div>

          <div className="legal-content">
            {legalDoc.paragraphs.map((text, index) => (
              <p
                className={getParagraphClassName(text, index)}
                key={`${legalType}-${index}`}
              >
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page-wrapper">
      <div className="login-card">
        <div className="login-header">
          {/*<CloseOutlined className="close-btn" onClick={onVisitor} />*/}
        </div>

        <div className="login-body">
          <img className="login-logo" src={loginTopImg} alt="阿喜健康" />
          {/* <h1 className="login-title">手机号登录</h1> */}

          <div className="input-group">
            <div className="input-item">
              <span className="input-label">手机号</span>
              <Input
                className="login-input"
                placeholder="请输入您的手机号"
                variant="borderless"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={11}
              />
            </div>
            <div className="input-item">
              <span className="input-label">验证码</span>
              <Input
                className="login-input"
                placeholder="请输入验证码"
                variant="borderless"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                maxLength={6}
              />
              {/* 倒计时按钮优化 */}
              <Button
                className="code-btn-styled"
                disabled={countdown > 0}
                onClick={handleSendSms}
              >
                {countdown > 0 ? `${countdown}s` : "获取验证码"}
              </Button>
            </div>
            {/* 邀请码（仅新用户展示，非必填，仅数字） */}
            {isNewUser === 1 && (
              <div className="input-item">
                <span className="input-label">邀请码</span>
                <Input
                  className="login-input"
                  placeholder="邀请码（非必填）"
                  variant="borderless"
                  value={inviteCode}
                  onChange={(e) =>
                    setInviteCode(e.target.value.replace(/\D/g, ""))
                  }
                  maxLength={8}
                />
              </div>
            )}
          </div>
          <div className="agreement-section">
            <Checkbox
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
            >
              我已阅读并同意
              <span
                className="link"
                onClick={(event) => handleGoAgreement("user", event)}
              >
                《用户协议》
              </span>
              及
              <span
                className="link"
                onClick={(event) => handleGoAgreement("privacy", event)}
              >
                《隐私政策》
              </span>
            </Checkbox>
          </div>
          <Button
            className="login-submit-btn"
            type="primary"
            loading={loading}
            onClick={handleLogin}
          >
            登录
          </Button>

          <Button
            className="login-cancel"
            type="primary"
            loading={loading}
            onClick={onVisitor}
          >
            取消登录
          </Button>
        </div>
      </div>
      <div className="adult">
        未成年人应当在监护人陪同、监护下使用本服务；若为未成年人，请勿独立使用
      </div>

      {/* 邀请码有误弹窗 */}
      {inviteErrorVisible && (
        <div className="invite-error-mask">
          <div className="invite-error-modal">
            <span
              className="invite-error-close"
              onClick={() => setInviteErrorVisible(false)}
            >
              ✕
            </span>
            <h3 className="invite-error-title">邀请码有误</h3>
            <p className="invite-error-desc">
              邀请码不正确或已失效
              <br />
              您可以修改后重试，或直接跳过邀请码
              <br />
              邀请码为选填项
            </p>
            <div className="invite-error-actions">
              <span
                className="invite-error-btn reenter"
                onClick={handleReenterInvite}
              >
                重输邀请码
              </span>
              <span className="invite-error-btn skip" onClick={handleSkipInvite}>
                跳过
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
